export const routesEn = {
  routes_Dashboard_MembershipEntriesPage: "Membership",
  routes_Dashboard_MembershipSubscriptionPage: "Membership",
  routes_Dashboard_OnboardingEntriesPage: "Select Your Entry",
  routes_Dashboard_OnboardingSubscriptionPage: "Subscribe Membership",
  routes_Dashboard_SettingsPage: "Settings",

  routes_ExamBoard_ExamBoardPage: "Exam Board",

  routes_ExamTaking_ExamQuizPage: "",

  routes_ExamReview_ExamReviewPage: "Revise",

  routes_SubscriptionManagement_PaymentPage: "Membership > Payment",

  routes_pages_Admin_AdminDashboard: "Dashboard",
  routes_pages_Admin_AdminEntryManager: "Entry Manager",
  routes_pages_Admin_AdminIndexManager: "Index Manager",
  routes_pages_Admin_AdminLogin: "Login",
  routes_pages_Admin_AdminPlanManager: "Plan Manager",
  routes_pages_Admin_AdminQuestionManager: "Question Manager",
  routes_pages_Admin_AdminQuestionManagerReportedQuestions:
    "Question Manager > Reported Questions",
  routes_pages_Admin_AdminRevenueManager: "Revenue Manager",
  routes_pages_Admin_AdminTestManager: "Test Manager",
  routes_pages_Admin_AdminTestManagerNewTemplate:
    "Test Manager > Add New Template",
  routes_pages_Admin_AdminUserManager: "User Manager",

  routes_Landing_LandingPage: "",
  routes_Landing_PasswordResetPage: "Password Reset",
  routes_Landing_TermsConditions: "Terms & Conditions",

  routes_ProgressOverview_ProgressOverviewPage: "Dashboard",
};
